<template>
  <div :class="$style.orderSubmission">
    <v-layout row
              wrap>
      <v-flex :class="$style.appGrid"
              :md12="!isGuest"
              :md8="isGuest"
              xs12>
        <DesktopConfirmationMain v-if="order"
                                 :data-fields="dataFields"
                                 :check-id="checkId"/>
      </v-flex>
      <v-flex v-if="isGuest"
              :class="$style.appGrid"
              xs12
              md4>
        <DesktopAdv/>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import moment from 'moment';
import { Getter, Action } from 'vuex-class';
import DesktopConfirmationMain from '@/apps/desktop/components/DesktopConfirmationMain';
import DesktopAdv from '@/apps/desktop/components/DesktopAdv';
import { CART_RESET, ORDER_RESET } from '@/apps/cart/store/types';
import { formatPhoneDots } from '@/lib/helpers';

/**
 * Page to display order confirmation data.
 */
@Component({
  name:       'DesktopConfirmation',
  components: {
    DesktopAdv,
    DesktopConfirmationMain,
  },
  props: {
    checkId: {
      type:     Number,
      required: true,
    },
  },
})
export default class DesktopConfirmation extends Vue {
  @Action(CART_RESET) cartReset;
  @Action(ORDER_RESET) orderReset;
  @Getter isAuthenticated;
  @Getter isGuest;
  @Getter authUser;
  @Getter order;
  @Getter restByKey;

  get restaurant() {
    return this.restByKey(this.order.restaurantId);
  }

  get dataFields() {
    return [
      {
        icon:  'user-icon',
        title: 'Your Name',
        value: this.order.recipientName,
      },
      {
        icon:  'phone-icon',
        title: 'Your Phone Number',
        value: formatPhoneDots(this.order.phone),
      },
      {
        icon:  'calendar-icon',
        title: 'Pickup Time / Date',
        value: moment.parseZone(this.order.pickupTime).format('MM/DD/YY @ h:mm A'),
      },
      {
        icon:  'map-marker',
        title: 'Pickup Location',
        value: this.restaurant.address,
      },
      {
        icon:  'clock-icon',
        title: 'Store Hour',
        value: this.restaurant.storeHours,
      },
      {
        icon:  'store-phone',
        title: 'Store Phone Number',
        value: formatPhoneDots(this.restaurant.phone),
      },
    ];
  }

  created() {
    this.cartReset();
  }
  destroyed() {
    this.orderReset();
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
@import "~@/style/helpers.scss";

$order-submission: #050504;

.appGrid {
  @extend %flex;
  z-index: 3;
}

.orderSubmission {
  display: flex;
  position: relative;
  min-height: 100%;
  z-index: 2;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: $kiosk-breakpoint-max) {
  .orderSubmission {
    background: url("/assets/img/burger-bg.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .orderSubmission::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: $order-submission;
    opacity: 0.85;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopConfirmation.vue